import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const navItems = [
  { label: "首页", to: "/" },
  { label: "吃瓜快讯", to: "/news" },
  { label: "专题栏目", to: "/topics" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-1.5 md:px-6">
          <p className="truncate text-xs">
            <span className="text-accent-300">●</span> 今日新瓜已更新 40+ 条 · 圈内秘闻持续放送
          </p>
          <p className="hidden whitespace-nowrap text-xs text-background-300 sm:block">
            吃瓜不迷路 · {siteInfo.slogan}
          </p>
        </div>
      </div>

      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-6 px-4 py-3 md:px-6">
          <Link to="/" className="flex items-center gap-2.5" aria-label={`${siteInfo.name} 首页`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-water-flash-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                {siteInfo.name}
              </span>
              <span className="mt-0.5 text-[11px] text-foreground-500">GUATIAN MIWENSHE</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-100 font-medium text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/news"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-3.5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 sm:flex"
            >
              <i className="ri-search-line"></i> 搜瓜
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开菜单"
              aria-expanded={open}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 md:hidden" aria-label="移动导航">
            <ul className="flex flex-col px-4 py-2">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={`flex items-center justify-between rounded-md px-3 py-3 text-sm ${
                      isActive(item.to)
                        ? "bg-primary-100 font-medium text-primary-800"
                        : "text-foreground-700"
                    }`}
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}